import { Vue, Component, Prop } from 'vue-property-decorator';
import store from '@/store';
import { openThirdPage } from '@/api/native/utils';
import { customServiceUrl } from '@/constant';

import style from './index.module.scss';

@Component
export default class Profile extends Vue {
  @Prop(String) readonly avatorIcon!: string;

  @Prop(String) readonly fontColor!: string;

  @Prop(String) readonly backgroundColor!: string;

  @Prop(String) readonly hiddenIcon!: boolean

  private get showAccount(): string {
    const userMobile = store.state.base.originUserInfo.mobile;

    if (userMobile) {
      return String(userMobile).replace(/\d{4}(?=\d{4}$)/, '****');
    }

    return '';
  }

  private callCustomService() {
    this.$ubtPageButton('臻有钱_我的_联系客服');
    openThirdPage(customServiceUrl);
  }

  private render() {
    return (
      <section
        class={style.profileContainer}
        style={
          this.backgroundColor && {
            backgroundColor: this.backgroundColor,
          }
        }
      >
        <div class={style.profileLeft}>
          <span
            class={style.avator}
            onClick={this.onClick.bind(this)}
            style={
              this.avatorIcon && {
                backgroundImage: this.avatorIcon,
              }
            }
          ></span>
          <span
            class={style.account}
            onClick={this.onClick.bind(this)}
            style={
              this.fontColor && {
                color: this.fontColor,
              }
            }
          >
            {this.showAccount}
          </span>
        </div>
        {!this.hiddenIcon && <div class={style.profileRight}>
          <span onClick={this.callCustomService.bind(this)} class={style.cs}></span>
          <span onClick={this.onClick.bind(this)} class={style.set}></span>
        </div>}
      </section>
    );
  }

  private onClick() {
    this.$emit('click');
  }
}
